export enum JobStates {
  Pending = 'pending',
  Running = 'running',
  Canceled = 'canceled',
  Success = 'success',
  Failed = 'failed',
  Unknown = 'unknown',
}

export enum TrainingStepEnum {
  NotStarted = -1,
  Scheduling = 0,
  PreparingDataset = 1,
  Training = 2,
  UploadingArtefacts = 3,
  CalculatingPerformance = 4,
  Completed = 5,
  Canceled = 6,
  Failed = 100,
}

export enum PipelineStates {
  Initializing = 'initializing',
  DownloadingDataset = 'downloading_dataset',
  CreatingFsDataset = 'creating_fs_dataset',
  TrainingRunning = 'training_running',
  TrainingFinished = 'training_finished',
  EvaluatingOnCompleteDataset = 'evaluating_on_complete_dataset',
  TuningThresholds = 'tuning_thresholds',
  UploadingTrainingArtifacts = 'uploading_training_artifacts',
  TrainingPipelineCompleted = 'training_pipeline_completed',
  ConfusionCalculationStarted = 'confusion_calculation_started',
  Completed = 'completed',
}
